import StoreModel from '../StoreModel';
import { Action, ActionCreator, Dispatch } from 'redux';
import { AddDeliveryDTO, AddRaceDTO, Race, RaceState } from '../../api/model';
import { NotificationActions } from '../notification/notification-actions';
import { AppDispatch, IStore } from '../index';
import { DriverActions } from '../driver';
import { getApi } from '../../api/ApiProvider';


export enum RaceActionsTypes {
    REQUEST_ADD = '[RACES][REQUEST] save',
    RESULT_ADD = '[RACES][RESPONSE] save',
    ERROR_ADD = '[RACES][ERROR] save',

    RESUME_FETCH = '[RACES][REQUEST] fetch',
    RESUME_RESULT = '[RACES][RESPONSE] fetch',
    RESUME_ERROR = '[RACES][ERROR] fetch',

    BY_STATE_FETCH = '[RACES][REQUEST] byState',
    BY_STATE_RESULT = '[RACES][RESULT] byState',
    BY_STATE_ERROR = '[RACES][ERROR] byState',

    ALL_FETCH = '[RACES][REQUEST] all',
    ALL_RESULT = '[RACES][RESULT] all',
    ALL_ERROR = '[RACES][ERROR] all',


    SINGLE_FETCH = '[RACES][REQUEST] single',
    SINGLE_RESULT = '[RACES][RESPONSE] single',
    SINGLE_ERROR = '[RACES][ERROR] single',

}


export interface AddRaceParams extends Action<RaceActionsTypes> {
    payload: Race
}

export class RaceActions {

    public fetchResume(): ActionCreator<void> {
        return async (d: Dispatch) => {

            d({ type: RaceActionsTypes.RESUME_FETCH });

            try {
                const data = await getApi().race().countByState();
                d({ type: RaceActionsTypes.RESUME_RESULT, payload: data });

            } catch (err) {
                d({ type: RaceActionsTypes.RESUME_ERROR, payload: err });
            }

        }
    }
    public fetchAll() {
        return async (d: Dispatch) => {

            d({ type: RaceActionsTypes.ALL_FETCH });

            try {
                const data = await getApi().race().all();
                d({ type: RaceActionsTypes.ALL_RESULT, payload: data });

            } catch (err) {
                d({ type: RaceActionsTypes.ALL_ERROR, payload: err });
            }

        }
    }

    fetchWithDriverInfo(id: string, force: boolean): any {
        return async (d: AppDispatch, store: () => IStore) => {

            const isLoaded = StoreModel.isLoaded(store().race.byId[id]);
            if (!force && isLoaded) {
                return;
            }

            if (!isLoaded) {
                d({ type: RaceActionsTypes.SINGLE_FETCH, payload: { id } });
            }
            try {
                const data = await getApi().race().byId(id);
                d({ type: RaceActionsTypes.SINGLE_RESULT, payload: { id, data } })
                if (data.driver) {
                    d(new DriverActions().fetchLocationById(data.driver.id))
                }
            } catch (err) {
                console.log('err', err);
                d({ type: RaceActionsTypes.SINGLE_ERROR, payload: { id, err } })
            }
        }
    }

    public addDelivery(delivery: AddDeliveryDTO): ActionCreator<void> {
        return (dispatch: AppDispatch) => {

            dispatch({ type: RaceActionsTypes.REQUEST_ADD });
            const notif = new NotificationActions();

            getApi().race().addDelivery(delivery).then(ok => {

                const action: AddRaceParams = {
                    type: RaceActionsTypes.RESULT_ADD,
                    payload: ok
                };

                dispatch(notif.addSuccess('Delivery', 'Agregada correctamente'));
                dispatch(action);
            }, err => {
                const action: AddRaceParams = {
                    type: RaceActionsTypes.ERROR_ADD,
                    payload: err
                };
                dispatch(action);
            });
        };
    }

    public add(race: AddRaceDTO): ActionCreator<void> {
        return (dispatch: AppDispatch) => {

            dispatch({ type: RaceActionsTypes.REQUEST_ADD });
            const notif = new NotificationActions();

            getApi().race().add(race).then(ok => {

                const action: AddRaceParams = {
                    type: RaceActionsTypes.RESULT_ADD,
                    payload: ok
                };

                dispatch(notif.addSuccess('Carrera', 'Agregada correctamente'));
                dispatch(action);
            }, err => {
                const action: AddRaceParams = {
                    type: RaceActionsTypes.ERROR_ADD,
                    payload: err
                };
                dispatch(action);
            });


        };
    }

    fetchByState(state: RaceState) {

        return (dispatch: Dispatch) => {

            dispatch({ type: RaceActionsTypes.BY_STATE_FETCH, state });
            getApi().race().listByState(state).then(data => {
                dispatch({ type: RaceActionsTypes.BY_STATE_RESULT, payload: data, state });
            }, err => {
                dispatch({ type: RaceActionsTypes.BY_STATE_ERROR, payload: err, state });
            });
        };

    }
}



// WEBPACK FOOTER //
// ./src/store/race/race-actions.ts